import {InitPage} from "../../index";
import {RemoveRenderLine} from "./remove_render_line";

declare var $;
declare var saveWOStateUrl;

class SaveWOState {
    constructor() {
        $('.saveWOState').on('click', function(){
            $('#search-item-clear').click();
            $('.edit_manufacturing_production').first().attr('action', saveWOStateUrl).submit();
        });

        var original = $('.edit_manufacturing_production').first().serialize();
        // window.addEventListener("beforeunload", function (e) {
            var form = $('.edit_manufacturing_production').first(),
            original = form.serialize()

            form.submit(function(){
                window.onbeforeunload = null
            })

            window.onbeforeunload = function(){
                if (form.serialize() != original)
                    return 'Are you sure you want to leave?'
            }
        // });

        $('.removeFullyConsumed').on('click', function(){
            RemoveRenderLine.removeFullyConsumed($(this).data('epc-id'));
        })

        $('.removeManuallyConsumed').on('click', function(){
            RemoveRenderLine.removeManuallyConsumed($(this).data('tag-id'));
        })
    }
}


export function LoadPage() {
    InitPage("production reconciliation", () => {
        const s = new SaveWOState();
    });
}
